import { Theme } from '@mui/material';

const Card = (theme: Theme) => {
  return {
  };
};

export default Card;
